import { useQuery } from '@tanstack/react-query';

import { getPrioritiesApi } from 'api/priorities';
import { RequestQueryKeysE, RequestStaleTimeE } from 'declarations/enums/react-query';
import { ApiErrorI } from 'declarations/interfaces/errors';
import { TicketPriorityI } from 'declarations/interfaces/ticketPriorities';

export const useFetchTicketPriorities = (isEnabled: boolean) =>
  useQuery<TicketPriorityI[], ApiErrorI>(
    [RequestQueryKeysE.FetchPriorities],
    () => getPrioritiesApi(),
    { enabled: isEnabled, staleTime: RequestStaleTimeE.ClaimStatuses }
  );
